module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "detailLayout mainLayout"
  }, [_c('div', {
    staticClass: "detailGroup"
  }, [_c('videoplayer', {
    attrs: {
      "videoID": _vm.$route.params.videoID,
      "previewType": "video"
    }
  })], 1), _vm._v(" "), (_vm.detailUrl) ? _c('social-sharing', {
    attrs: {
      "url": _vm.detailUrl,
      "title": "Vota per questo rutto su garadirutti.tk!",
      "description": "Vota per questo #rutto per farlo salire in calssifica su www.garadirutti.tk",
      "quote": "Vota per questo video per farlo salire in classifica!",
      "hashtags": "rutto,gara,classifica,burp"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', {
            staticClass: "detailGroup shareMe"
          }, [_c('span', {
            staticClass: "textBase"
          }, [_vm._v("\n\t\t\t\tCondividi il video per votare sui social\n\t\t\t")]), _vm._v(" "), (!_vm.shareAPI) ? _c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "gdr-icon gdr-icon-facebook"
          })]) : _vm._e(), _vm._v(" "), (!_vm.shareAPI) ? _c('network', {
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "gdr-icon gdr-icon-twitter"
          })]) : _vm._e(), _vm._v(" "), (_vm.shareAPI) ? _c('button', {
            staticClass: "webShareAPI",
            on: {
              "click": _vm.shareTo
            }
          }, [_vm._v("\n\t\t\t\tCondividi\n\t\t\t")]) : _vm._e()], 1)
        
      },
      staticRenderFns: []
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fb87b7e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detailLayout.vue
// module id = 238
// module chunks = 3